export const SET_USER = 'user/SET_USER';
export const CLEAR_USER = 'user/CLEAR_USER';
